import PropTypes from 'prop-types';
export var validChartTypes = PropTypes.oneOf(['chart', 'stockChart']);
export var validAxisTypes = PropTypes.oneOf(['category', 'linear', 'logarithmic', 'datetime']);